import React, { Component } from 'react'
import PropTypes from 'prop-types'

import CSSModules from 'react-css-modules'
import FontIcon from 'react-toolbox/lib/font_icon'
import { Flex, Box } from 'reflexbox'

import StatusColorHoc from './StatusColorHoc'
import TimelineLeftSubSection from './TimelineLeftSubSection'
import TimelineMiddleSubSection from './TimelineMiddleSubSection'
import TimelineRightSubSection from './TimelineRightSubSection'
import TimelineDivider from './TimelineDivider'
import TimelinePoint from './TimelinePoint'

import styles from './styles.scss'

const TimelineSubSection = (props) => {
  let {
    leftItem,
    rightItem,
    ...rest
  } = props
  return (
    <Flex styleName='subsection' auto>
      <TimelineLeftSubSection>
        { StatusColorHoc(rest, leftItem) }
      </TimelineLeftSubSection>
      <TimelineMiddleSubSection>
        { StatusColorHoc(rest, TimelinePoint) }
        { StatusColorHoc(rest, TimelineDivider) }
      </TimelineMiddleSubSection>
      <TimelineRightSubSection>
        { StatusColorHoc({ ...rest, right: true }, rightItem) }
      </TimelineRightSubSection>
    </Flex>
  )
}

TimelineSubSection.propTypes = {
}

export default CSSModules(TimelineSubSection, styles)
